import React, { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import styles from './Layout.module.css';

interface LayoutProps {
  children: ReactNode;
  headerActions?: ReactNode;
  scrollable?: boolean;
}

export function Layout({ children, headerActions, scrollable = false }: LayoutProps) {
  return (
    <div className={`${styles.layout}${scrollable ? ` ${styles.layoutScrollable}` : ''}`}>
      <Header headerActions={headerActions} />
      <div className={styles.content}>
        <main className={styles.main}>{children}</main>
      </div>
      <Footer />
    </div>
  );
}
